import React from 'react';
import { bool, func } from 'prop-types';
import { BiArrowBack } from 'react-icons/bi';
import loadable from '@loadable/component';

import {
  Box,
  Button,
  Center,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  DrawerCloseButton,
  Image,
} from '@chakra-ui/react';

const LoadableGallerry = loadable(() =>
  import(/* webpackChunkName: "invitato-gallery-photos" */ './Gallery'),
);

import ImgWave from '@/components/Common/Wave/assets/wave-v4.svg';
import useSPH from '@hooks/useSPH';
import { SPH_LOGO_BLACK } from '@/constants/sph';

function PhotoContent({ isOpen, onClose }) {
  const sph = useSPH();

  return (
    <Drawer size="full" isOpen={isOpen} onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent maxW="500px">
        <DrawerCloseButton color="transparent" />
        <DrawerBody bgColor="bgPrimary" width="100%" padding="0">
          <Box bgImage={`url(${sph.imgCover})`} height="450px" bgSize="cover" bgPosition="center" />
          <Box
            backgroundImage={`url(${ImgWave})`}
            width="100%"
            height="40px"
            transform="translateY(-38px)"
          />
          {/* <Box height="38px" marginTop="-60px" /> */}
          <Center>
            <Image src={SPH_LOGO_BLACK} height="70px" marginTop="16px" />
          </Center>
          {/* Images Cover */}
          <Box padding="32px" textAlign="center" color="mainColorText">
            {/* Jakarta Section */}
            <Box paddingTop="28px">
              <Box marginTop="24px">{isOpen && <LoadableGallerry data={sph.gallery} />}</Box>
            </Box>
          </Box>
          <Center padding="16px 0 48px 0">
            <Button
              leftIcon={<BiArrowBack />}
              size="sm"
              fontWeight="light"
              color="bgAlternative"
              variant="outline"
              colorScheme="blackAlpha"
              onClick={() => onClose()}
            >
              Back
            </Button>
          </Center>
          <Box height="50px" />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}

PhotoContent.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
};

export default PhotoContent;
